import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-ice px-5 py-20 sm:py-28" data-id="element-99" data-mp="1l9o779vjm1m9">
      <div className="mx-auto max-w-3xl" data-id="element-100" data-mp="1ge0g2oxi2ye4">
        <h2 className="text-center font-display text-[1.9rem] font-extrabold leading-tight tracking-tight text-navy sm:text-[2.8rem]" data-id="element-101" data-mp="1gaurrbwp40jg">
          <span aria-hidden="true" data-id="element-102" data-mp="2913elh26f94d">❓ </span>Häufig gestellte Fragen
        </h2>

        <div className="mt-12 space-y-3" data-id="element-103" data-mp="24208dtagmwut">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-2xl bg-white shadow-lift" data-id="element-104" data-mp="1z2no9gaz43vx" data-mpi={index}>
                <h3 data-id="element-105" data-mp="soo97vpnb2ez">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40" data-id="element-106" data-mp="sl0g2xo44i0s">
                    <span className="font-display text-base font-bold text-navy" data-id="element-107" data-mp="fiyqbusfpu3q">{faq.q}</span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-brand text-white' : 'bg-ice text-brand'}`} data-id="element-108" data-mp="khtllw7l9b4q">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-109" data-mp="3t0hls0d403e5" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-110" data-mp="3jy8851mjntwj">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-111" data-mp="3nzk37mo6t7c4">
                      <p className="px-6 pb-5 text-[15px] leading-relaxed text-navy/75" data-id="element-112" data-mp="1krks89u50gza">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}